import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../../appSharedModule/services/utils.service';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {AssignmentService} from '../../../services/assignment.service';
import {AuthenticationService} from '../../../../authenticationModule/services/authentication.service';
import {WorkVisitService} from '../../../services/work-visit.service';
import {WorkVisit} from '../../../models/workVisit';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-document-crud',
  templateUrl: './assignment-details.component.html',
  styleUrls: ['./assignment-details.component.scss'],
  host: {class: 'sym-page'}
})
export class AssignmentDetailsComponent implements OnInit {

  hostingManagerUrl = environment.hostingManagerUrl;
  currentAssignment: any;
  loading = true;

  workVisitTableCols = [
    {field: 'cab', header: 'Half Cab', sortable: false},
    {field: 'pop', header: 'Pop', sortable: false},
    {field: 'dateFrom', header: 'Date from', sortable: true},
    {field: 'dateTo', header: 'Date to', sortable: true},
    {field: 'status', header: 'Status', sortable: true},
    {field: 'jiraIssue', header: 'Jira ticket', sortable: true},
    {field: 'requestedDate', header: 'Request date', sortable: true},
    {field: 'updatedAt', header: 'Updated date', sortable: true},
    {field: 'actions', header: 'Actions', sortable: false}
  ];
  workVisitList: WorkVisit[] = [];
  xcoColumns = [
    {field: 'creationDate', header: 'Creation date', isDefault: true, globalFilter: true},
    {field: 'customer', header: 'Customer', isDefault: true, globalFilter: true},
    {field: 'service', header: 'Service', isDefault: true, globalFilter: true},
    {field: 'mckayOrganization', header: 'Mckay organization', isDefault: true, globalFilter: true},
    {field: 'sender', header: 'Sender', isDefault: true, globalFilter: true},
    {field: 'crossConnectId', header: 'CrossConnectId', isDefault: true, globalFilter: true},
    {field: 'status', header: 'Status', isDefault: true, globalFilter: true},
    {field: 'sentDate', header: 'Sent date', isDefault: true, globalFilter: true},
    {field: 'finalStatus', header: 'Final status', isDefault: true, globalFilter: true},
    {field: 'finalStatusDate', header: 'Final status date', isDefault: true, globalFilter: true},
  ];
  xcos = [];
  loadingXcos = true;
  loaUrl = environment.loaUrl;

  constructor(private utilsService: UtilsService,
              private authenticationService: AuthenticationService,
              private assignmentService: AssignmentService,
              private workVisitService: WorkVisitService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.utilsService.lockUi();
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const assignmentId = paramMap['params']['id'];
      if (assignmentId !== null && typeof assignmentId !== 'undefined') {
        this.assignmentService.getAssignment(assignmentId).subscribe(res => {
          this.currentAssignment = res;
          this.assignmentService.getAssignmentPocs(assignmentId).subscribe(res => {
            this.currentAssignment.pocs = res.pocs;
          });
          this.loading = false;
          this.utilsService.unlockUi();
          this.retrieveAssignmentXcos(assignmentId);
        });
        this.retrieveAssignmentWorkVisits(assignmentId);
      } else {
        this.utilsService.unlockUi();
        location.assign('/#/404');
      }
    });
  }

  private retrieveAssignmentWorkVisits(assignmentId) {
    this.workVisitService.getAssignmentWorkVisits(assignmentId).subscribe(res => {
      this.workVisitList = res.sort((a, b) => {
        return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
      });
    });
  }

  private retrieveAssignmentXcos(assignmentId) {
    this.assignmentService.getXcos(assignmentId).subscribe({
      next: res => {
        this.xcos = res.filter(xco => xco.accountId === this.currentAssignment.accountId);
        this.loadingXcos = false;
      }
    });
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  getJiraLink(jiraId: string) {
    return 'https://mckay-brothers.atlassian.net/browse/' + jiraId;
  }

  cancelWorkVisit(workVisit) {
    if (confirm('Are you sure you want to cancel the work visit?')) {
      this.workVisitService.cancelWorkVisit(workVisit).subscribe(
        () => {
          workVisit.status = 'Cancelled';
        }
      );
    }
  }

  getWorkVisitStatusClass(status: string): string {
    const value = (status || '').toLowerCase();
    if (value.includes('draft') || value.includes('pending') || value.includes('review')) {
      return 'wv-status-warn';
    }
    if (value.includes('rejected') || value.includes('cancelled')) {
      return 'wv-status-bad';
    }
    if (value.includes('completed') || value.includes('approved') || value.includes('accepted')) {
      return 'wv-status-good';
    }
    return 'wv-status-neutral';
  }
}
